import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Filial } from '../../filial/filial';
import { FilialService } from '../../filial/filial.service';
import { MedicoFilial } from '../../medico/medico-filial';
import { MedicoService } from '../../medico/medico.service';
import { MedicoFilialPk } from '../../medico/pks/medico-filial-pk';
import { AbastractAssociacao } from '../abstract.associacao';

@Component({
  selector: 'app-associacao-filial-medico',
  templateUrl: '../associacao.component.html',
  styleUrls: ['../associacao.component.css']
})
export class AssociacaoFilialMedicoComponent extends AbastractAssociacao {

  constructor(private filialService: FilialService,
    private medicoService: MedicoService,
    formBuilder: FormBuilder,
    dialog: MatDialog) {

    super(formBuilder, dialog);

  }

  ngOnInit() {

    super.ngOnInit();

    this.tituloAssociacao = 'Associação Filial x Médico';
    this.nomeCampoAssociacaoPai = 'Filial';
    this.nomeCampoAssociacaoFilho = 'Médico';

    this.configurarForm();
  }

  getListaDePais(): Observable<any> {

    return this.filialService.listarFiliaisComRelacaoMinimaDeMedico();

  }

  getListaDeFilhos(): Observable<any> {

    return this.medicoService.listarComProjecao();

  }

  getListaDeFilhosSelecionados(): any {

    return (this.associacaoPai as Filial).medicoFilial;

  }

  getIdFilhoFromAssociacaoComPai(currentAssociacao: any): any {

    return currentAssociacao.pk.idMedico;
  }

  configurarAssociacoesFilhas(associacoesFilhas: any): void {

    let pai: Filial = this.associacaoPai as Filial;

    pai.medicoFilial = [];

    if (associacoesFilhas) {

      associacoesFilhas.forEach((currentFilho: any) => {
        pai.medicoFilial.push(this.getAssociacaoPaiFilho(currentFilho));
      });

    }
  }

  getAssociacaoPaiFilho(currentFilho: any): any {

    const associacao: MedicoFilial = new MedicoFilial();
    associacao.pk = new MedicoFilialPk();
    associacao.pk.idFilial = this.associacaoPai.id;
    associacao.pk.idMedico = currentFilho.id;

    return associacao;

  }

  salvarAssociacao(value: any): Observable<Object> {

    return this.filialService.atualizaRelacaoFilialMedico(value);
  }

}
